import {
  KinoklubCinemaChoices,
  KinoklubHallLucernaChoices,
  KinoklubHallOkoChoices,
  KinoklubHallSvetozorChoices,
  KinoklubLanguage,
  KinoklubProgramOptions
} from './interfaces';

export const programUrl = (
  lang: KinoklubLanguage,
  cinemas?: Array<KinoklubCinemaChoices | number>,
  options: KinoklubProgramOptions = {}
): string => {
  const defaultCinemas: Array<KinoklubCinemaChoices | number> = [
    KinoklubCinemaChoices.Aero,
    KinoklubCinemaChoices.Oko,
    KinoklubCinemaChoices.Svetozor
  ];
  const cinemaArr = cinemas && cinemas.length > 0 ? cinemas : defaultCinemas;
  const cinemaParams = cinemaArr.map((c) => `cinema%5B%5D=${c}`).join('&');

  const isAllDays = options.allDays;

  // Map cinema to halls
  let halls: number[] = [];
  for (const cinema of cinemaArr) {
    switch (cinema) {
      case KinoklubCinemaChoices.Svetozor:
        halls.push(
          ...Object.values(KinoklubHallSvetozorChoices).filter((value) => typeof value === 'number')
        );
        break;
      case KinoklubCinemaChoices.Lucerna:
        halls.push(
          ...Object.values(KinoklubHallLucernaChoices).filter((value) => typeof value === 'number')
        );
        break;
      case KinoklubCinemaChoices.Oko:
        halls.push(
          ...Object.values(KinoklubHallOkoChoices).filter((value) => typeof value === 'number')
        );
        break;
      default:
        // if cinema has no halls, do nothing
        break;
    }
  }
  // Remove duplicate halls and sort
  halls = Array.from(new Set(halls)).sort((a, b) => a - b);
  const hallParams = halls.map((h) => `hall%5B%5D=${h}`).join('&');
  const url = `https://www.kinoaero.cz/api_program?${cinemaParams}${hallParams ? '&' + hallParams : ''}&ef=0&m=&wp=0&arch=0&ao=0&d=${isAllDays ? '2' : '0'}&_locale=${lang}`;
  console.log(url);
  return url;
};

export const movieUrl = (movieId: number, lang: KinoklubLanguage): string =>
  `https://www.kinoaero.cz/api_film/?pr=${movieId}&_locale=${lang}`;

export const ticketsRedirectUrl = 'https://kinoklub-tickets-redirect.bart-acf.workers.dev';
